module.exports = __webpack_public_path__ + "static/media/me.18e0a007.png";